module.exports = __webpack_public_path__ + "static/junior-7-05a617b4d59684c9f3c3f19112eeefb6.png";